import { initialFinancialEducationState } from './journey';

export default () => {
    return {
        financialEducation: initialFinancialEducationState
    }   
}
